export type MessageTarget =
  | { kind: 'serviceProvider'; serviceProviderId: string }
  | { kind: 'user'; recipientUserId: string };

export type ResolveMessageTargetParams = {
  serviceProviderId: string | null;
  recipientUserId: string | null;
  /** Temporary backwards-compatible alias for recipientUserId — new code must not emit it. */
  recipient: string | null;
};

/**
 * Reads the mutually-exclusive SP-vs-user recipient identity off a message
 * deep link (spec §3.1). Returns `null` when no target parameter is present,
 * and `'ambiguous'` when more than one is — the caller must fail closed
 * rather than guess which one wins.
 */
export function resolveMessageTarget({
  serviceProviderId,
  recipientUserId,
  recipient,
}: ResolveMessageTargetParams): MessageTarget | null | 'ambiguous' {
  const presentCount = [serviceProviderId, recipientUserId, recipient].filter(Boolean).length;
  if (presentCount > 1) {
    return 'ambiguous';
  }
  if (serviceProviderId) {
    return { kind: 'serviceProvider', serviceProviderId };
  }
  const userId = recipientUserId ?? recipient;
  return userId ? { kind: 'user', recipientUserId: userId } : null;
}
